export const colors = {
  green: '#668c4f',
  dark: '#433E3A',
  orange: '#EA994B',
  blue: '#0083FF',
  red: '#FF5F5F'
}